define(
    "diy/undo-redo/EntryFactory",
    [
        'diy/undo-redo/Entry',
        'diy/undo-redo/historyEntry/Factory'
    ],
    /**
     *
     * @param {module.undoRedo.Entry} Entry
     * @param {module.undoRedo.HistoryEntry.Factory} HistoryEntryFactory
     * @returns {*}
     */
    function (Entry, HistoryEntryFactory) {
        'use strict';

        var EntryFactory;
        /**
         * @class module.undoRedo.EntryFactory
         * @template module.undoRedo.EntryFactory
         * @lends {module.undoRedo.EntryFactory.prototype}
         * @constructor
         */
        EntryFactory = Klazz.extend({

            /** @type {module.undoRedo.HistoryEntry.Factory} */
            historyEntryFactory: null,

            /**
             *
             * @param {module.undoRedo.Api} api
             */
            initialize: function (api) {
                this.historyEntryFactory = new HistoryEntryFactory(api);
            },

            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} historyEntry
             * @returns {module.undoRedo.Entry}
             */
            create: function create(historyEntry) {
                return new Entry(historyEntry);
            },
            /**
             *
             * @param {String} type
             * @param {Object} payload
             * @param {String} payload.executionType
             * @param {String} payload.entryType
             * @param {Boolean} payload.isSessionHead
             * @returns {module.undoRedo.Entry}
             */
            load: function load(type, payload) {
                var
                    /** @type {module.undoRedo.HistoryEntry.Base} */
                    historyEntry = this.historyEntryFactory.load(type, payload),
                    /** @type {module.undoRedo.Entry} */
                    entry = this.create(historyEntry)
                    ;

                entry
                    .setIsSessionHead(payload.isSessionHead)
                    .setType(historyEntry.getEntryType())
                ;

                return entry;
            },

            /**
             *
             * @param {String} type
             * @param {Object} payload
             * @param {String=} message
             * @param {String=} undoSessionId
             * @param {Number=} undoSessionIndex
             * @param {Boolean=} isExecutable
             * @returns {module.undoRedo.Entry}
             */
            build: function build(type, payload, message, undoSessionId, undoSessionIndex, isExecutable) {
                var
                    /** @type {module.undoRedo.HistoryEntry.Base} */
                    historyEntry = this.historyEntryFactory.build(type, payload, message, undoSessionId, undoSessionIndex, isExecutable);

                return this.create(historyEntry);
            },

            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} historyEntry
             * @returns {module.undoRedo.Entry}
             */
            wrap: function wrap(historyEntry) {
                return new Entry(historyEntry);
            }
        });

        return EntryFactory;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/EntryFactory.js
 ** module id = 896
 ** module chunks = 0
 **/